<template lang="pug">
  aside.fixed.z-50.top-0.right-0.w-full.h-full.sm-w-1x2.md-w-1x3.lg-w-1x4.bg-white.sm-shadow.overflow-y-scroll.scrolling-touch.flex.flex-col(v-if="checkout")
    //- header
    header.sticky.z-10.top-0.left-0
      .h-164.bg-white-95.w-full.flex.flex-col.justify-between
        .pt-8.flex.items-start.justify-between.pl-12.pr-6
          div
            h3.text-22 CART
          button.p-6(@click="$emit('close')")
            svg-x(style="width:1.5rem;height:1.5rem")
        .px-12.pb-16.flex.justify-between.items-end.border-b(v-if="cartCount")
          //- span.text-22.leading-none CART
          .leading-none.pb-2
            span.inline-block.mr-em ITEMS
            span.text-19 {{cartCount}}
          .leading-none.pb-2
            span.inline-block.mr-em TOTAL
            span.text-26 {{ formatPrice(checkout.paymentDue) }}
    //- items
    ul.flex-1.list-reset.-mb-px
      template(v-for="n in 1")
        li.relative.border-b.flex.flex-wrap(v-for="itm in checkout.lineItems")
          header.w-1x2.p-12.text-14
            //- title
            h5.uppercase
              span.text-14 {{ itm.title }}&#32;
              span.text-14(v-if="isOption(itm)") ({{ itm.variant.title }})
            //- price
            h6
              //- current price
              span(:class="{'text-black': price(itm.variant).reduced }")
                | {{ price(itm.variant).price }}
              //- (compare at)
              span.line-through.text-gray-500.inline-block.ml-6(v-if="price(itm.variant).reduced")
                | {{ price(itm.variant).compareAt }}
            //- qty
            .w-full.flex.items-end.mt-4
              label.block.py-2
                span.text-9 X
              .block.flex-1.flex-grow.px-2.ml-2
                qty-input.block.w-full.px-6.py-2.hover-bg-gray-100.focus-bg-gray-100(:value="itm.quantity", @change="updateQty($event, itm)")
          figure.w-1x2
            .relative(style="padding-bottom:100%")
              resp-img(v-if="cart", :bg="true", :src="itm.variant.image.src", :alt="itm.variant.image.alt", bgClass="bg-contain bg-bottom", :key="itm.variant.image.src")
              //- img.absolute.inset-0.w-full.h-full.object-contain(src="https://cdn.shopify.com/s/files/1/1220/9360/products/10-Look-295-Ottolinger-Shop.jpg?v=1553871624")
          //- remove btn
          button.absolute.p-12.text-black.right-0.top-0(@click="updateQty(0, itm)", aria-label="Remove Item from Cart")
            svg-x(style="width:1.1rem;height:1.1rem")
    footer.sticky.bottom-0.left-0.w-full.bg-white
      wp-rich-text.p-12.text-12.border-t(:html="footerText", v-if="footerText.length")
      a.block.w-full.h-90.uppercase.flex.items-center.justify-center.text-19.border-t.px-12.hover-bg-black.hover-text-white.trans-fast(v-if="cartCount", :href="checkout.webUrl", target="_blank", rel="noopener noreferrer")
        | Checkout ☞
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { formatPrice } from '@/utils'
import svgX from '@/components/icons/SVG-X'
import RespImg from '@/components/RespImg'
import QtyInput from '@/components/QtyInput'
import wpRichText from '@/components/WPRichText'
export default {
  name: 'Cart',
  data () {
    return {
      formatPrice
    }
  },
  computed: {
    ...mapState(['site', 'checkout', 'cart', 'winH']),
    ...mapGetters(['cartCount', 'price']),
    footerText () {
      return (this.site && this.site.cart_footer_text) || ''
    }
  },
  methods: {
    updateQty (event, item) {
      if (isNaN(event) || this.checkoutUpdating) return false
      this.$store.dispatch('updateCartItems', [{ id: item.id, quantity: Number(event) }])
    },
    isOption (itm) {
      return itm.variant.title.toLowerCase() !== 'default title'
    }
  },
  watch: {
    cartCount (newVal, old) {
      if (!newVal) return this.$store.commit('hideCart')
    }
  },
  components: { RespImg, svgX, QtyInput, wpRichText }
}
</script>

<style>
</style>
